/* eslint-disable */
import { HttpClient, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { structuralClone } from '../../api-helpers';
import { InternalDownloadUpdateMultipartBody, fixInternalDownloadUpdateMultipartBodyToJson } from '../dto/internal-download-update-multipart-body';

export interface PostInternalDownloadUpdateParams {
  body: InternalDownloadUpdateMultipartBody;
}

export function httpPostInternalDownloadUpdate(http: HttpClient, data: PostInternalDownloadUpdateParams, options?: { reportProgress?: boolean; observe?: 'body' }): Observable<void>;
export function httpPostInternalDownloadUpdate(http: HttpClient, data: PostInternalDownloadUpdateParams, options?: { reportProgress?: boolean; observe?: 'events' }): Observable<HttpEvent<void>>;
export function httpPostInternalDownloadUpdate(http: HttpClient, data: PostInternalDownloadUpdateParams, options: { reportProgress?: boolean; observe?: 'body' | 'events' } = {}): Observable<any> {
  return structuralClone(data).pipe(
    switchMap((dataClone) => {
      fixInternalDownloadUpdateMultipartBodyToJson(dataClone.body);
      const body = dataClone.body;
      const form = new FormData();
      if (body.id != null) {
        form.append('Id', body.id as unknown as string);
      }
      if (body.title != null) {
        form.append('Title', body.title as unknown as string);
      }
      if (body.productShorthands != null) {
        body.productShorthands.forEach((obj,idx) => {form.append('ProductShorthands', obj as unknown as string)});
      }
      if (body.customerIds != null) {
        body.customerIds.forEach((obj,idx) => {form.append('CustomerIds', obj as unknown as string)});
      }
      if (body.categoryId != null) {
        form.append('CategoryId', body.categoryId as unknown as string);
      }
      if (body.language != null) {
        form.append('Language', body.language as unknown as string);
      }
      if (body.version != null) {
        form.append('Version', body.version as unknown as string);
      }
      if (body.description != null) {
        form.append('Description', body.description as unknown as string);
      }
      if (body.databaseSystem != null) {
        form.append('DatabaseSystem', body.databaseSystem as unknown as string);
      }
      if (body.dateValidFrom != null) {
        form.append('DateValidFrom', body.dateValidFrom.toISOString() as unknown as string);
      }
      if (body.dateExpired != null) {
        form.append('DateExpired', body.dateExpired.toISOString() as unknown as string);
      }
      if (body.hideForSaasCustomer != null) {
        form.append('HideForSaasCustomer', body.hideForSaasCustomer as unknown as string);
      }
      if (body.visibleForServiceAgents != null) {
        form.append('VisibleForServiceAgents', body.visibleForServiceAgents as unknown as string);
      }
      if (body.file != null) {
        form.append('File', body.file);
      }
      return http.post<void>(`{placeholder}/InternalDownload/Update`, form, options as any);
    })
  );
};

export const urlPostInternalDownloadUpdate = (baseUrl: string, data: PostInternalDownloadUpdateParams) => {
  return `${baseUrl}/InternalDownload/Update`;
};
